export default __webpack_public_path__ + "static/media/Bolo-De-Noz.5a98c2ca.jpg";